import _ from "lodash";
import { laborObjFields } from "../../../../constants/fields.constant";

export const laborToForm = (_labor, { qty = 1, filterLabor }) => {
    if (!_.isObject(_labor)) _labor = JSON.parse(_labor);
    const selectedLabor = filterLabor ? filterLabor(_labor.id) : {};
    if ((!selectedLabor || !selectedLabor.skill) && !_labor.name) return;
    const labor = _.cloneDeep(laborObjFields)
    labor.name.value = _labor.name || selectedLabor.skill;
    labor.id.value = _labor.id;
    labor.skillDescription.value = _labor.skillDescription || '';
    // this value will be selectedLabor.cost when the resource is not selected in cost/levels so average cost(without profit) will be update by default
    labor.costPerItem.value = parseFloat(selectedLabor.cost || selectedLabor.averageCost || _labor.cost || 0);
    labor.calloutCost.value = parseFloat(_labor.calloutCost || 0);
    labor.labourCost.value = parseFloat(selectedLabor.averageCost || _labor.averageCost || 0);
    labor.travelCost.value = 0;
    labor.labor_cost = selectedLabor.averageCost || _labor.averageCost;
    labor.labor_profit = 0;
    labor.qty.value = Number(_labor.qty || 1) * qty;
    labor.is_personnel.value = selectedLabor.is_personnel !== undefined
        ? selectedLabor.is_personnel
        : (_labor.is_personnel !== undefined
            ? _labor.is_personnel
            : true);
    labor.total.value = parseFloat(labor.qty.value) * parseFloat(labor.costPerItem.value);

    return labor
}

export const updateLaborSubtask = (subTask, templateLabors, itemToUpdate) => {
    return subTask.labor.map((labor, index) => {
        const templateLabor = templateLabors.find(tempLabor => tempLabor.id === labor.id.value);
        const templateLaborQty = templateLabor ? Number(templateLabor.qty) : '';
        if (templateLaborQty) {
            return {
                ...labor,
                qty: {
                    ...labor.qty,
                    value: (Number(itemToUpdate.templateQuantity) * Number(templateLaborQty))
                },
                total: {
                    ...labor.total,
                    value: (Number(itemToUpdate.templateQuantity) * Number(templateLaborQty) * Number(labor.labourCost.value))
                }
            };
        } else return labor;

    });
}
